/**
 * @desc Yung-获取审批业务key
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.ResponseDto<string>;
export function request(body: defs.rms.ApprovalBeforeRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/approval/getBusinessKey`, {
      method: "GET",

      data: body,
      ...options,
    }),
  );
}
